import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface AutomationRuleCardProps {
  name: string;
  description: string;
  status: "enabled" | "disabled" | "planned";
}

export function AutomationRuleCard({ name, description, status }: AutomationRuleCardProps) {
  return (
    <Card className="shadow-card">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">{name}</CardTitle>
          <Badge variant={status === "enabled" ? "default" : "secondary"}>
            {status === "enabled" ? "Enabled" : status === "disabled" ? "Disabled" : "Planned"}
          </Badge>
        </div>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-2">
          <Switch checked={status === "enabled"} disabled={status === "planned"} />
          <Label>{status === "enabled" ? "Rule is active" : "Rule is inactive"}</Label>
        </div>
      </CardContent>
    </Card>
  );
}
